import cls from "./AdminHistoryPanel.module.scss";

export default function AdminHistoryPanel({ history }) {
  const items = history?.items || [];

  return (
    <section className={cls.panel}>
      <div className={cls.header}>
        <p className={cls.kicker}>MATCH LOGS</p>
        <h3 className={cls.title}>Recent Turn History</h3>
      </div>

      {!items.length ? (
        <p className={cls.empty}>No turn history yet.</p>
      ) : (
        <ul className={cls.list}>
          {items.map((item) => (
            <li key={item.turnId || `${item.roundNumber}-${item.questionTitle}`}>
              <div className={cls.rowTop}>
                <strong>Round {item.roundNumber || "-"}</strong>
                <span className={cls.status}>{item.status || "-"}</span>
              </div>
              <p className={cls.question}>{item.questionTitle || "Question"}</p>
              <p className={cls.meta}>
                {item.answerPlayer?.displayName || "-"} vs {item.guessPlayer?.displayName || "-"}
              </p>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
